import React from 'react';
import SearchForm from '../components/SearchForm';

export default function HeroSection() {
  return (
    <div className="relative bg-[#0a0f2e] text-white overflow-hidden">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-15%] right-[-5%] w-72 h-72 sm:w-[500px] sm:h-[500px] bg-blue-700 opacity-25 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-5%] w-60 h-60 sm:w-[400px] sm:h-[400px] bg-cyan-500 opacity-20 rounded-full blur-[100px]" />
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(to right, #ffffff 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-0">
        <div className="flex justify-center mb-6">
          <span className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 text-yellow-300 text-xs font-bold px-4 py-2 rounded-full tracking-widest uppercase">
            <span className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse" />
            Live Deal Alert — Fares Updated Every Hour
          </span>
        </div>

        <div className="text-center mb-6 sm:mb-8">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black leading-[1.05] tracking-tight mb-4">
            Hunt the Deal.
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-blue-300 to-yellow-300">
              Book the Flight.
            </span>
          </h1>
          <p className="text-slate-300 text-base sm:text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            We scan every airline, every hour — surfacing the biggest price drops on US domestic and international flights before they disappear.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8">
          {['🔥 Flash Deals Updated Hourly', '💸 Up to 70% Off Regular Fares', '🚨 Low-Fare Alerts', '⚡ No Booking Fees'].map(pill => (
            <span key={pill} className="bg-white/8 border border-white/15 text-white/80 text-xs sm:text-sm px-3 sm:px-4 py-1.5 rounded-full">{pill}</span>
          ))}
        </div>

        <div className="bg-white/6 backdrop-blur-2xl border border-white/10 rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-8 shadow-2xl max-w-5xl mx-auto">
          <SearchForm />
        </div>

        <div className="mt-8 sm:mt-10 pb-12 sm:pb-16 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 max-w-2xl sm:max-w-none mx-auto">
          {[
            { value: '70%', label: 'Max Savings Found' },
            { value: '500+', label: 'Daily Deal Alerts' },
            { value: '150+', label: 'Airlines Scanned' },
            { value: '$0', label: 'Booking Fee' },
          ].map(s => (
            <div key={s.label} className="text-center">
              <p className="text-2xl sm:text-3xl font-black text-cyan-400">{s.value}</p>
              <p className="text-slate-400 text-xs sm:text-sm mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="relative h-12 sm:h-16 -mt-1">
        <svg viewBox="0 0 1440 64" preserveAspectRatio="none" className="absolute bottom-0 w-full h-full" fill="white">
          <path d="M0,64 C480,0 960,64 1440,0 L1440,64 Z" />
        </svg>
      </div>
    </div>
  );
}
